import { ShiftReportStackerBundle } from "@/pages/shift-report/models/ShiftReportResponse";
import { ColDef } from "ag-grid-enterprise";

const formatLength = (totalInches: number | null): string => {
	if (totalInches == null) return "";
	const abs = Math.abs(Math.round(totalInches));
	return `${Math.floor(abs / 12)}' ${abs % 12}"`;
};

const formatBundlesPcs = (
	bundles: number | null,
	pcs: number | null,
): string => {
	if (!bundles && !pcs) return "-";
	return `${bundles ?? 0} × ${pcs ?? 0}`;
};

export const useTableData = () => {
	const columnDefs: ColDef<ShiftReportStackerBundle>[] = [
		{
			field: "SectionName",
			headerName: "Section",
			minWidth: 80,
			flex: 1,
			cellStyle: { justifyContent: "center" },
		},
		{
			field: "HeatName",
			headerName: "Heat",
			minWidth: 80,
			flex: 1,
			valueFormatter: (params) => params.value || "-",
			cellStyle: { justifyContent: "center" },
		},
		{
			field: "GradeName",
			headerName: "Grade",
			minWidth: 80,
			flex: 1,
			valueFormatter: (params) => params.value || "-",
			cellStyle: { justifyContent: "center" },
		},
		{
			field: "LengthInches",
			headerName: "Length",
			minWidth: 70,
			flex: 1,
			valueFormatter: (params) => formatLength(params.value),
			cellStyle: { justifyContent: "center" },
		},
		{
			headerName: "Good (Bdl × Pcs)",
			minWidth: 90,
			flex: 1,
			valueGetter: (params) =>
				`${params.data?.GoodBundles ?? 0} × ${params.data?.GoodPiecesPerBundle ?? 0}`,
			cellStyle: { justifyContent: "center" },
		},
		{
			field: "TotalPieces",
			headerName: "Total Pieces",
			minWidth: 80,
			flex: 1,
			valueFormatter: (params) =>
				params.value != null ? params.value.toLocaleString() : "",
			cellStyle: { justifyContent: "center" },
		},
		{
			field: "TotalWeight",
			headerName: "Total Weight",
			minWidth: 80,
			flex: 1,
			valueFormatter: (params) =>
				params.value != null ? params.value.toLocaleString() : "-",
			cellStyle: { justifyContent: "center" },
		},
		{
			headerName: "Scrap (Bdl × Pcs)",
			minWidth: 90,
			flex: 1,
			valueGetter: (params) =>
				formatBundlesPcs(
					params.data?.ScrapBundles ?? null,
					params.data?.ScrapPiecesPerBundle ?? null,
				),
			cellStyle: { justifyContent: "center" },
		},
		{
			field: "ScrapReason",
			headerName: "Reason for Scrap",
			minWidth: 120,
			flex: 1.5,
			valueFormatter: (params) => params.value || "-",
			cellStyle: { justifyContent: "flex-start" },
		},
	];

	return { columnDefs };
};
